const firebaseConfig = {
  apiKey: "AIzaSyC-u87P0r74u2CGl9HSxAv1m-2KirwiMc8",
  authDomain: "city-ride-7b5d1.firebaseapp.com",
  projectId: "city-ride-7b5d1",
  storageBucket: "city-ride-7b5d1.appspot.com",
  messagingSenderId: "492684551036",
  appId: "1:492684551036:web:3314884fabcb44819d7af9",
};
export default firebaseConfig;
